import { ModerationRow } from 'modules/admin/dashboard/types';
import { Card } from 'shared/components/ui/Card';
import { Button } from 'shared/components/ui/Button';
import { useState } from 'react';
import { useToast } from 'shared/components/ui/Toast';

interface ModerationQueueProps {
  items: ModerationRow[];
}

export function ModerationQueue({ items }: ModerationQueueProps) {
  const toast = useToast();
  // Itens já decididos saem da fila nesta sessão (mock: a decisão não é persistida).
  const [decidedIds, setDecidedIds] = useState<string[]>([]);
  const pending = items.filter((item) => !decidedIds.includes(item.id));

  function decide(item: ModerationRow, approved: boolean) {
    setDecidedIds((current) => [...current, item.id]);
    toast(
      approved
        ? { title: 'Publicação aprovada', description: `O post de ${item.arenaName} continua visível no mural.` }
        : { title: 'Publicação removida', description: `Removida do mural de ${item.arenaName}. O histórico fica guardado.` }
    );
  }

  if (pending.length === 0) {
    return (
      <Card>
        <h3 className="font-heading font-semibold text-ink">Moderação de conteúdo</h3>
        <p className="mt-2 text-sm text-ink-secondary">Nenhum item pendente de moderação.</p>
      </Card>
    );
  }

  return (
    <Card>
      <h3 className="font-heading font-semibold text-ink">Moderação de conteúdo</h3>

      <div className="mt-3 divide-y divide-border/70">
        {pending.map((item) => (
          <div key={item.id} className="py-3">
            <p className="text-sm font-medium text-ink">{item.arenaName}</p>
            <p className="mt-1 text-sm text-ink-secondary">{item.excerpt}</p>
            <p className="mt-1 text-xs text-ink-secondary">Motivo: {item.reason}</p>
            <div className="mt-2 flex gap-2">
              <Button variant="ghost" className="flex-1 px-3 py-1 text-xs" onClick={() => decide(item, true)}>
                Aprovar
              </Button>
              <Button className="flex-1 px-3 py-1 text-xs" onClick={() => decide(item, false)}>
                Remover
              </Button>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
